import { j as s } from "./index.es33.js";
import { memo as r } from "react";
import { Typography as m } from "./index.es35.js";
import "./index.es36.js";
import i from "./index.es623.js";
var l = function l(_ref) {
    var o = _ref.data,
      e = _ref.name;
    return s.jsx("div", {
      children: o.length > 0 || e === "Searching results" ? s.jsxs(s.Fragment, {
        children: [s.jsx(m.Small, {
          className: i.caption,
          children: e
        }), o.length > 0 ? s.jsx("ul", {
          className: i.emojiList,
          children: o.map(function (t) {
            return s.jsx(m.Body1, {
              className: i.emoji,
              as: "li",
              children: s.jsx("button", {
                type: "button",
                className: i.emojiSymbol,
                children: t.emoji
              })
            }, "".concat(e, "-").concat(t.description));
          })
        }) : s.jsx(m.Body2, {
          children: "We didn't find anything ;("
        })]
      }) : ""
    });
  },
  p = /*#__PURE__*/r(l);
export { p as default };